import * as React from "react";
import {Button} from "react-bootstrap";
import IconButton from "../../../components/button/IconButton";


const columns = (t) => [
    {
        field: "machineType",
        label: t ? t("common.machine_type") : "Typ maszyny",
        sort: "desc",
        width: 53,
        type: "enum",
        enumType: "enums/machineType",
    },
    {
        label: t ? t("common.machine_model") : "Model maszyny",
        field: "machinePresentableName",
        sort: "desc",
        width: 53,
    },
    {
        field: "verified",
        label: t ? t("common.configured") : "Skonfigurowano",
        sort: "desc",
        width: 53,
        type: "custom",
        custom: function (column, row, history) {
            return <h4>
                {
                    row.machineModelId ?
                        <i className="far fa-check-circle text-primary"></i> :
                        <i className="far fa-times-circle text-secondary"></i>
                }
            </h4>
        }

    }


];

export default columns;